// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--HsM5g","fadeSlideUp":"fadeSlideUp--TPqBw"};